export const convertToTimeSpanFormat = (time: string): string => {
  // Timespan example - "PT12H30M"
  const timeSpan = time
    .split(':')
    .map((x, index) => (index === 0 ? `${x}H` : `${x}M`))
    .join('');

  return `PT${timeSpan}`;
};
